<template>
  <b-modal
    id="activity-log-modal"
    title="User Activity Logs"
    size="xl"
    centered
    hide-footer
    @shown="handleFetchActivityLogs"
    body-class="modal-body-scrollable"
  >
    <div>
      <b-table
        :items="items"
        :fields="fields"
        show-empty
        responsive
        :busy="loadingActivities"
        thead-class="text-nowrap"
      >
        <template #cell(dateTime)="{ item }">
          <span class="text-nowrap">{{
            format(new Date(item.createdTime), "dd/MM/yyyy hh:mm aa")
          }}</span>
        </template>
        <template #cell(action)="{ item }">
          <span class="text-nowrap">{{ item.action || "-" }}</span>
        </template>

        <template #cell(details)="{ item }">
          <span class="text-nowrap">{{ item.detail || "-" }}</span>
        </template>
        <template #cell(changes)="{ item }">
          <span class="text-nowrap">{{ item.jsonData || "-" }}</span>
        </template>
        <template #cell(notes)="{ item }">
          <span class="text-nowrap">{{ item.note || "-" }}</span>
        </template>
        <template #cell(ipAddress)="{ item }">
          <span class="text-nowrap">{{ item.ipAddress || "-" }}</span>
        </template>
      </b-table>
      <div
        v-if="paginationActivities.total > 0"
        class="d-flex align-items-center justify-content-between mt-1"
      >
        <div class="text-muted small">{{ paginationSummary }}</div>
        <div
          class="d-flex align-items-center justify-content-center justify-content-sm-end"
        >
          <b-pagination
            v-model="page"
            :total-rows="paginationActivities.total"
            :per-page="paginationActivities.limit"
            first-number
            last-number
            class="mb-0 mt-1 mt-sm-0"
            prev-class="prev-item"
            next-class="next-item"
          >
            <template #first-text
              ><span class="text-success">First</span></template
            >
            <template #prev-text>
              <feather-icon icon="ChevronLeftIcon" size="18" />
            </template>
            <template #next-text>
              <feather-icon icon="ChevronRightIcon" size="18" />
            </template>
            <template #last-text><span class="text-info">Last</span></template>
          </b-pagination>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import { BModal, BTable, BPagination } from "bootstrap-vue";
import { mapState, mapActions } from "vuex";
import { format } from "date-fns";
export default {
  components: {
    BModal,
    BTable,
    BPagination,
  },
  data() {
    return {
      fields: [
        { key: "dateTime", label: "Date/Time" },
        { key: "action", label: "Action" },
        { key: "details", label: "Details" },
        { key: "changes", label: "Changes" },
        { key: "notes", label: "Notes" },
        { key: "ipAddress", label: "IP Address" },
      ],
      items: [],
      page: 1,
    };
  },
  watch: {
    page() {
      this.handleFetchActivityLogs();
    },
  },
  computed: {
    ...mapState("user/detail", ["loadingActivities", "paginationActivities"]),
    paginationSummary() {
      const p = this.paginationActivities || {};
      const page = Number(p.page) || 1;
      const limit = Number(p.limit || p.perPage) || 10;
      const total = Number(p.total) || 0;

      const from = total === 0 ? 0 : (page - 1) * limit + 1;
      const to = total === 0 ? 0 : Math.min(page * limit, total);

      return total === 0
        ? `Showing 0 of 0 items`
        : `Showing ${from} - ${to} of ${total} items`;
    },
  },
  methods: {
    ...mapActions("user/detail", ["getActivityLogsByUser"]),
    format,
    async handleFetchActivityLogs() {
      const result = await this.getActivityLogsByUser({
        userId: this.$route.params.id,
        page: this.page,
      });
      this.items = result;
    },
  },
};
</script>

<style>
.modal-body-scrollable {
  max-height: 70vh;
  overflow-y: auto;
}
</style>
